import { CalendarIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from "react-redux";
import * as XLSX from 'xlsx';
import { getLotteryData } from "../services/LotteryService";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toDate } from "date-fns";
const MySwal = withReactContent(Swal);

export default function Lottery() {
    const { user } = useSelector((state) => state.auth);
    const [lotteryData, setLottery] = useState([])

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);


    const downloadExcel = () => {
        let data = lotteryData;
        // Transform data for Excel
        const excelData = data.map((item, index) => ({
            'No': index + 1,
            'Ebeveyn Adı': item.data.parentName,
            'Ebeveyn Soyadı': item.data.parentSurname,
            'Telefon': item.data.parentPhone,
            'İl': item.data.parentCity,
            'Adres': item.data.parentAddress,
            'Çocuk Adı': item.data.childName,
            'Çocuk Soyadı': item.data.childSurname,
            'Çocuk Yaşı': item.data.childAge,
            'SMS Kodu': item.data.smsCode,
            'Şartlar Kabul Edildi': item.data.termsAccepted ? 'Evet' : 'Hayır',
            'Tarih': item.date,
            'Belge No': item.documentName
        }));

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        const colWidths = [
            { wch: 5 },  // No
            { wch: 15 }, // Veli Adı
            { wch: 15 }, // Veli Soyadı
            { wch: 15 }, // Veli Telefon
            { wch: 15 }, // Veli İl
            { wch: 40 }, // Veli Adresi
            { wch: 15 }, // Çocuk Adı
            { wch: 15 }, // Çocuk Soyadı
            { wch: 10 }, // Çocuk Yaşı
            { wch: 10 }, // SMS Kodu
            { wch: 15 }, // Şartlar Kabul Edildi
            { wch: 20 }, // Tarih
            { wch: 25 }, // Belge No
        ];
        ws['!cols'] = colWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Kayıt Verileri');

        // Save file
        XLSX.writeFile(wb, 'cekilis_verileri.xlsx');
    };


    const fetchLottery = async () => {
        setLoading(true)
        const data = await getLotteryData(startDate, endDate);
        setLottery(data?.data)
        setLoading(false)
        console.log('data.data', JSON.stringify(data.data))
    }

    useEffect(() => {
        fetchLottery()
    }, [startDate, endDate])

    return (
        <div className="space-y-8">
            <div className="flex justify-between">

                <div className='px-4 py-2  sm:px-6 lg:px-8 sm:flex-auto'>
                    <h1 className='text-lg font-bold leading-6 text-gray-900'>
                        Çekilişe Katılanlar (Toplam: {lotteryData.length})
                    </h1>
                </div>

                <div className="">

                    <div className="flex items-center gap-2">
                        <CalendarIcon size={20} className="text-gray-500" />
                        <div className="flex items-center gap-2">
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat="dd/MM/yyyy"
                                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                placeholderText="Başlangıç Tarihi"
                            />
                            <span className="text-gray-500">-</span>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                dateFormat="dd/MM/yyyy"
                                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                placeholderText="Bitiş Tarihi"
                            />
                        </div>
                    </div>
                </div>

                <div className="flex ml-5">
                    <button
                        className='rounded-md bg-indigo-600 px-8 py-2 text-sm font-bold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                        onClick={downloadExcel}
                    >
                        Excel İndir
                    </button>
                </div>
            </div>


            <div className="">
                {loading ? <>Yükleniyor...</> : 
                <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                        <tr className="hover:bg-slate-300">
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Tarih
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Ebeveyn Adı
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Ebeveyn Soyadı
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Telefon
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                İl
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Adres
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Çocuk Adı
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Çocuk Soyadı
                            </th>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                Çocuk Yaşı
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white ">
                        {lotteryData && lotteryData.length > 0 && lotteryData.map(n => (
                            <tr>
                                <td style={{ width: 500, padding: 10 }}>{n.data.date}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.parentName}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.parentSurname}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.parentPhone}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.parentCity}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.parentAddress}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.childName}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.childSurname}</td>
                                <td style={{ width: 500, padding: 10 }}>{n.data.childAge}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>}
            </div>
        </div>

    );
}
